export const countryCodes = [
  { id: '+977', name: '+977' },
  // { id: '+978', name: '+978' },
  // { id: '+923', name: '+978' },
];
